import React from 'react';
import {
    NavigationContainer,
    NavigationItem,
    NavigationItemsContainer,
    NavigationSubscriptionButton
} from './UbisoftPlusNavigationStyle';
import { IContent } from '../../types';
import { INavigationItem } from '../../types/content';
import { getNavigationPageLink, redirectUser } from '../../utils/navigation';
import SubscriptionButton from '../utils/SubscriptionButton';
import { withContent } from '../../hoc/withContext';
import { getSvgComponent } from '../utils/svg';
import { adobeTrack } from '../../utils';

interface INavigationProps {
    context?: IContent;
}

function navigationItemClicked(linkKey: string, trackingCode: string) {
    let navigationLink = getNavigationPageLink(linkKey);
    adobeTrack(trackingCode);
    redirectUser(navigationLink);
}

const UbisoftPlusNavigation = ({ context }: INavigationProps) => {
    return (
        <NavigationContainer>
            {getSvgComponent('ubisoft')}
            <NavigationItemsContainer>
                {context.navigation.map((item: INavigationItem, index) => (
                    <NavigationItem
                        key={`nav-${item.key}`}
                        onClick={() =>
                            navigationItemClicked(item.key, item.tracking)
                        }
                        isCurrentPage={item.key === 'cloud'}
                        isLastItem={context.navigation.length - 1 === index}
                    >
                        {item.text}
                    </NavigationItem>
                ))}
            </NavigationItemsContainer>
            <NavigationSubscriptionButton>
                <SubscriptionButton idToAttach={'navigationSubscription'} />
            </NavigationSubscriptionButton>
        </NavigationContainer>
    );
};

export default withContent(UbisoftPlusNavigation);